import { render, staticRenderFns } from "./CancelarImportacaoModal.vue?vue&type=template&id=49d73b1c"
import script from "./CancelarImportacaoModal.vue?vue&type=script&lang=js"
export * from "./CancelarImportacaoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports